import React from 'react';
/**
 * WUT's `common/uniqueId.js`, as a hook:
 *
 *   let idCounter = 0;
 *   export default (prefix) => `${prefix}-${++idCounter}`;
 *
 * This exists because `React.useId` MUST NOT be used in this library. It is a React 18 API, and
 * `comments-widget` runs in a host that serves the React 16.14 UMD build, so calling it throws
 * `TypeError: i(...).useId is not a function` during render and the widget mounts nothing. The
 * package declaring `react: ^18` is no guide: react is external, so the host's version is what
 * runs.
 *
 * A counter is what upstream shipped, so this is also the faithful port. `useId`'s advantage —
 * identical ids across SSR and hydration — does not apply to how these ids are used: they only tie
 * a label to an input or an `aria-describedby` to its message, where a differing id costs a
 * hydration warning rather than behaviour. The ref keeps the value stable across re-renders.
 */
let idCounter = 0;
export const useUniqueId = (prefix) => {
    const ref = React.useRef();
    if (!ref.current) {
        ref.current = `${prefix}-${++idCounter}`;
    }
    return ref.current;
};
//# sourceMappingURL=useUniqueId.js.map